import { useSinglePickerField } from '../Picker/useSinglePickerField';
export const useThumbnailCarouselField = useSinglePickerField;
